import api from "../api"
export default {
	async getChain(transactionID) {
		let value = await api.get(`/transactions/${transactionID}/chain`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	}
}